import { useState, useEffect, useRef, useCallback } from 'react';
import { checkScrapingStatus, shouldStartAutoRefresh, shouldStopAutoRefresh } from '../utils/scrapingStatus';

export const useAutoRefresh = (onRefresh, refreshInterval = 5000) => {
  const [isAutoRefreshing, setIsAutoRefreshing] = useState(false);
  const autoRefreshInterval = useRef(null);

  const handleCheckScrapingStatus = useCallback(async () => {
    try {
      const status = await checkScrapingStatus();
      
      if (shouldStartAutoRefresh(status, isAutoRefreshing)) {
        setIsAutoRefreshing(true);
        if (onRefresh) {
          onRefresh();
        }
      } else if (shouldStopAutoRefresh(status, isAutoRefreshing)) {
        setIsAutoRefreshing(false);
      }
    } catch (error) {
      console.error('Error in handleCheckScrapingStatus:', error);
      // Don't keep polling if there are API errors
      setIsAutoRefreshing(false);
    }
  }, [isAutoRefreshing, onRefresh]);

  // Set up auto-refresh interval
  useEffect(() => {
    if (isAutoRefreshing) {
      autoRefreshInterval.current = setInterval(handleCheckScrapingStatus, refreshInterval);
    } else {
      if (autoRefreshInterval.current) {
        clearInterval(autoRefreshInterval.current);
        autoRefreshInterval.current = null;
      }
    }

    return () => {
      if (autoRefreshInterval.current) {
        clearInterval(autoRefreshInterval.current);
      }
    };
  }, [isAutoRefreshing, handleCheckScrapingStatus, refreshInterval]);

  // Check scraping status when component mounts
  useEffect(() => {
    handleCheckScrapingStatus();
  }, [handleCheckScrapingStatus]);

  return {
    isAutoRefreshing,
    setIsAutoRefreshing,
    checkScrapingStatus: handleCheckScrapingStatus
  };
};